/**
 * @file delete.tsx
 * @module app/modals/delete
 * @description Renders the delete modal dialog for confirming actions, capturing workflow input, and reporting outcomes to its parent screen.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 2.1.2
 */

import { Modal, Button } from 'react-bootstrap';
import { useState } from 'react';
import APICallService from '../../api/apiCallService';
import { useNavigate } from 'react-router-dom';
import { success } from '../../Global/toast';
import { String } from '../../utils/string';
import CrossSvg from '../../_admin/assets/media/svg_uTrade/cross-rounded-gray.svg';

const DeleteModal = (props: any) => {

  return (
    <>
      <Modal
        {...props}
        show={props.show}
        onHide={props.onHide}
        dialogClassName="modal-dialog-centered min-w-lg-590px"
        className="border-r10px"
        centered
        backdrop="static"
      >
        <Modal.Header className="border-bottom-0 d-flex justify-content-end position-relative">
          <img
            className="position-absolute top-0 end-0 mt-n5 me-n5"
            width={40}
            height={40}
            src={CrossSvg}
            alt="closebutton"
            onClick={props.onHide}
          />
        </Modal.Header>
        <Modal.Body className="pt-0 pb-1">
          <Modal.Title className="fs-24 fw-bolder text-center pt-lg-3 pb-5">
           {props.message}
          </Modal.Title>
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="bg-light-danger text-center border-r10px p-3">
                <span className="fs-16 fw-500">
                 {props.error ? props.error : props.warnMessage}
                </span>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-center mb-4 border-top-0">
          {(!props.error) && (
            <>
              <Button className="uw-btn uw-btn-danger uw-btn-lg"
                variant="danger"
                size="lg"
                onClick={() => {
                  props.handleDelete();
                }}
                disabled={props.loading}
              >
                {!props.loading ? (
                  <span className="indicator-label fs-16 fw-bold">
                    Delete this {props.serviceName}
                  </span>
                ) : (
                  <span
                    className="indicator-progress fs-16 fw-bold"
                    style={{ display: 'block' }}
                  >
                    {String.PleaseWait}
                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                  </span>
                )}
              </Button>
            </>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default DeleteModal;
